var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 17.16,
    viewBox: "0 0 20 17.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2619",
    "data-name": "Rectangle 2619",
    width: 20,
    height: 17.16,
    fill: "#1b7934"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1777",
    "data-name": "Group 1777",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1776",
    "data-name": "Group 1776",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14644",
    "data-name": "Path 14644",
    d: "M18.333,6.027a1.589,1.589,0,0,1,1.146.521A1.589,1.589,0,0,1,20,7.693v1.32a1.637,1.637,0,0,1-.034.347,1.252,1.252,0,0,1-.1.3l-2.754,6.458a1.529,1.529,0,0,1-.776.764,2.5,2.5,0,0,1-1.1.278L5,17.138V6.027L10.417.61A2.032,2.032,0,0,1,11.423.043,1.383,1.383,0,0,1,12.442.17a1.191,1.191,0,0,1,.579.822,2.912,2.912,0,0,1-.012,1.238l-.787,3.8ZM6.667,6.721v8.75h8.889l2.778-6.458V7.693H10.186l1.133-5.6Zm-5,10.417a1.59,1.59,0,0,1-1.192-.49A1.628,1.628,0,0,1,0,15.471V7.693A1.626,1.626,0,0,1,.474,6.517a1.59,1.59,0,0,1,1.192-.49H5V7.693H1.667v7.778H5v1.667Zm5-1.667v0Z",
    transform: "translate(0 0)",
    fill: "#1b7934"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.767bd3b38f98a4391bcd0016367769f7.svg";
export { ForwardRef as ReactComponent };